import type { Publication } from '~/interfaces/publication';

// This method is a fallback in case the proper rootstyles are not returned from the API.
// You can find the proper rootstyles logic in Swarm at: https://github.com/beehiiv/swarm/blob/main/app/services/orchid/web_theme/root_styles.rb
const getRootStyles = (publication: Publication, backgroundColorOverride?: string, textColorOverride?: string) => {
  return `
    html:root {
      --wt-primary-color: ${publication?.web_theme?.primary_color};
      --wt-text-on-primary-color: ${publication?.web_theme?.text_on_primary_color};
      --wt-secondary-color: ${publication?.web_theme?.secondary_color};
      --wt-text-on-secondary-color: ${publication?.web_theme?.text_on_secondary_color};
      --wt-tertiary-color: ${publication?.web_theme?.tertiary_color};
      --wt-text-on-tertiary-color: ${publication?.web_theme?.text_on_tertiary_color};
      --wt-background-color: ${backgroundColorOverride || publication?.web_theme?.background_color};
      --wt-text-on-background-color: ${textColorOverride || publication?.web_theme?.text_on_background_color};
      --wt-subscribe-background-color: ${publication?.web_theme?.subscribe_background_color};
      --wt-text-on-subscribe-background-color: ${publication?.web_theme?.text_on_subscribe_background_color};
      --wt-header-font: "${publication?.web_theme?.header_font}", ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
      --wt-body-font: "${publication?.web_theme?.body_font}", ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
      --wt-button-font: "${publication?.web_theme?.button_font}", ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
      --wt-border-radius: ${publication?.web_theme?.border_radius};
    }
    .wt-header-font { font-family: var(--wt-header-font); }
    .wt-body-font { font-family: var(--wt-body-font); }
    .wt-button-font { font-family: var(--wt-button-font); }
    input:focus { --tw-ring-color: transparent !important; }
    `;
};

export default getRootStyles;
